var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { id: _vm.modalId, "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("txtLabels")) +
                  "\n                "
              ),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#" + _vm.modalId
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-6 container" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("b", [_vm._v(" " + _vm._s(_vm.$t("txtLabels")) + " ")])
                    ]),
                    _vm._v(" "),
                    _vm.assignedLabels && _vm.assignedLabels.length
                      ? _vm._l(_vm.assignedLabels, function(label) {
                          return _c("div", {
                            staticClass: "row mb-1 add_card_label",
                            style: { "background-color": label.colorTag },
                            on: {
                              click: function($event) {
                                return _vm.remove(label)
                              }
                            }
                          })
                        })
                      : [
                          _c("div", { staticClass: "row" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s("(" + _vm.$t("txtEmpty") + ")") +
                                "\n                            "
                            )
                          ])
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-6 container" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("b", [_vm._v(_vm._s(_vm.$t("txtAvailable")))])
                    ]),
                    _vm._v(" "),
                    _vm.unassignedLabels.length
                      ? _vm._l(_vm.unassignedLabels, function(label) {
                          return _c("div", {
                            staticClass: "row mb-1 add_card_label",
                            style: { "background-color": label.colorTag },
                            on: {
                              click: function($event) {
                                return _vm.add(label)
                              }
                            }
                          })
                        })
                      : [
                          _c("div", { staticClass: "row" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s("(" + _vm.$t("txtEmpty") + ")") +
                                "\n                            "
                            )
                          ])
                        ]
                  ],
                  2
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("txtLabel")) +
                  "\n            "
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }